import { Col, Input, Row } from 'reactstrap';
import PropTypes from 'prop-types';

const FiltrosFila3 = ({ deudores, handleDeudor }) => (
  <Row className="mt-auto mt-md-2">
    <Col sm="3">
      <label htmlFor="deudores" className="form-label">
        Deudores
      </label>
      <Input
        type="checkbox"
        id="deudores"
        name="deudores"
        className="ms-4"
        checked={deudores}
        onChange={handleDeudor}
      />
    </Col>
  </Row>
);

FiltrosFila3.propTypes = {
  deudores: PropTypes.bool,
  handleDeudor: PropTypes.func.isRequired,
};

export default FiltrosFila3;
